import React from "react"

import OU from "../../Assessts/Images/Home/Parterns/OU.png";
import VNRVJIET from "../../Assessts/Images/Home/Parterns/VNRVJIET.png";
import Assamgovt from "../../Assessts/Images/Home/Parterns/Assam govt.png";
import YDF from "../../Assessts/Images/Home/Parterns/YDF.png";
import { Row, Col } from "react-bootstrap";

const Patners = () => {
    const Implementation = [{ img: OU }, { img: VNRVJIET }, { img: Assamgovt }, { img: YDF }]

    return (
        <div className="p-4 H-Partners">
            <div className="Web-MainHeading mb-3">Our Partners</div>
            <div className="container-fluid  mb-3 " style={{ width: "fit-content" }}>
                <Row className="dflex gap-5">
                    {Implementation.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} style={{height:"150px"}} /> </Col>
                    ))}
                </Row>
            </div>
        </div>
    )
};
export default Patners;